import { baseState } from './state'
import Vue from 'vue'
import { js_beautify as jsBeautify } from 'js-beautify'

// Might want to change it to UUID
const indexBy = 'id'

// Page mutations
const mutations = {
  // Normalize data and save all pages to store
  SET (state, request) {
    state.pages = request.data
    state.pages.forEach(page => {
      page.contentLanguages = {}
      page.contents.forEach(content => {
        page.contentLanguages[content.language_id] = 1
      })
    })
    state.currentPage = parseInt(request.headers['x-pagination-current-page'])
    state.totalPageCount = parseInt(request.headers['x-pagination-page-count'])
  },

  // Add new page to store
  ADD (state, page) {
    Vue.set(state.pages, page[indexBy], page)
  },

  // Remove page from store
  REMOVE (state, key) {
    Vue.delete(state.pages, key)
  },

  UPDATE (state, page) {
    Vue.set(state.pages, page[indexBy], page)
  },

  UPDATE_PROP (state, { page, prop, value }) {
    page[prop] = value
    Vue.set(state.pages, page[indexBy], page)
  },

  // Make page active
  SET_ACTIVE (state, key = null) {
    state.active = key
  },

  SET_NEW (state, page) {
    let newPage = {
      ...page,
      group: {}
    }
    if (newPage.groups && newPage.groups[0]) {
      newPage.group = newPage.groups[0]
    }
    if (!newPage.content) {
      newPage.content = {
        ...baseState().newPage.content,
        language_id: page.languageId,
        language: {
          id: page.languageId
        }
      }
    }
    newPage.content.layout = this.state.layout.layouts[newPage.content.layout_id]
    newPage.content.components = newPage.content.content
    delete newPage.content.content
    state.newPage = newPage
  },

  UPDATE_NEW ({ newPage }, { key, value }) {
    newPage[key] = value
  },

  UPDATE_NEW_CONTENT ({ newPage }, { key, value }) {
    newPage.content[key] = value
  },

  CLEAR_NEW (state) {
    let cleanPage = baseState().newPage
    state.newPage = {
      ...cleanPage,
      content: {
        ...cleanPage.content
      }
    }
  },

  SET_PER_PAGE (state, perPage) {
    state.perPage = perPage
  },

  SET_REVISIONS (state, request) {
    state.revisions = {
      revisions: request.data,
      currentPage: parseInt(request.headers['x-pagination-current-page']),
      totalPageCount: parseInt(request.headers['x-pagination-page-count']),
      totalCount: parseInt(request.headers['x-pagination-total-count'])
    }
  },

  CLEAR_REVISIONS (state) {
    state.revisions = {
      revisions: [],
      currentPage: 1,
      totalPageCount: 1,
      totalCount: 0
    }
  },

  SELECT_REVISION (state, revision) {
    const newPage = {
      ...state.newPage,
      content: {
        ...revision,
        components: revision.content
      }
    }

    if (revision.layout_id) {
      newPage.content.layout = this.state.layout.layouts[revision.layout_id]
    }

    const newPageHasContent = !!state.newPage.content.content
    if (newPageHasContent) {
      newPage.content.content = jsBeautify(
        JSON.stringify(revision.content),
        {
          indent_size: 2
        }
      )
    }

    state.newPage = newPage
  },

  TOGGLE_COLLAPSE (state, key) {
    state.cardCollapsed[key] = !state.cardCollapsed[key]
  }
}

export default mutations
